export const LOGIN_ROUTE = "/login";

export const HOME_ROUTE = "/";
export const FARMER_ROUTE = "/agriculteur";
export const COLLECTIVITY_ROUTE = "/collectivite";

export const COOKIE_ROUTE = HOME_ROUTE + "cookies";
export const ACCESSIBILITY_ROUTE = HOME_ROUTE + "accessibilite";
export const TERMS_OF_USE_ROUTE = HOME_ROUTE + "mentions_legales";

export const TASKS_ROUTE = "/tasks";

export const ENDPOINTS_ROUTE = "/endpoints";

export const COMPONENTS_ROUTE = "/components";

export const ERROR_404_ROUTE = "/404";
export const MAINTENANCE_ROUTE = "/maintenance";

export const E2E_SELECT_USER = "/e2e/users";
